import React from 'react';
import Game from './Game';
import ReversiGame from './ReversiGame';
import CheckersGame from './CheckersGame';
import JungleGame from './JungleGame';
import XiangqiGame from './XiangqiGame';
import TigerChickenGame from './TigerChickenGame';
import TicTacToeGame from './TicTacToeGame';
import Match3Router from './Match3Router';
import ConnectFourGame from './ConnectFourGame';
import HnefataflGame from './HnefataflGame';
import StraightChessGame from './StraightChessGame';
import TablutGame from './TablutGame';
import { GameMode, Difficulty, GameType } from '../types/game';
import { Match3Mode } from '../utils/match3';

interface GameRouterProps {
  gameMode: GameMode;
  difficulty?: Difficulty;
  gameType: GameType;
  match3Mode?: Match3Mode;
  playerColor?: 'black' | 'white'; // 直棋玩家颜色
  onBackToMenu?: () => void;
  onBackToModeSelect?: () => void;
}

const GameRouter: React.FC<GameRouterProps> = ({ gameMode, difficulty, gameType, match3Mode, playerColor, onBackToMenu, onBackToModeSelect }) => {
  // 根据游戏类型渲染不同的游戏组件
  if (gameType === 'reversi') {
    return (
      <ReversiGame
        gameMode={gameMode}
        difficulty={difficulty}
        onBackToMenu={onBackToMenu}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  if (gameType === 'checkers') {
    return (
      <CheckersGame
        gameMode={gameMode}
        difficulty={difficulty}
        onBackToMenu={onBackToMenu}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  if (gameType === 'jungle') {
    return (
      <JungleGame
        gameMode={gameMode}
        difficulty={difficulty}
        onBackToMenu={onBackToMenu}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  if (gameType === 'xiangqi') {
    return (
      <XiangqiGame
        gameMode={gameMode}
        difficulty={difficulty}
        onBackToMenu={onBackToMenu}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  if (gameType === 'tigerchicken') {
    return (
      <TigerChickenGame
        gameMode={gameMode}
        difficulty={difficulty}
        onBack={onBackToMenu}
        onGameEnd={() => {}}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  if (gameType === 'tictactoe') {
    return (
      <TicTacToeGame
        gameMode={gameMode}
        difficulty={difficulty}
        onBack={onBackToMenu}
        onGameEnd={() => {}}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  if (gameType === 'match3') {
    // 如果已经传递了match3Mode，使用它；否则根据GameMode和Difficulty映射到Match3Mode
    let finalMatch3Mode: Match3Mode;
    if (match3Mode) {
      finalMatch3Mode = match3Mode; // 使用传递过来的模式
    } else {
      // 兼容性：根据GameMode和Difficulty映射模式
      if (gameMode === 'pvp') {
        finalMatch3Mode = 'classic'; // 双人对战 → 经典宝石模式
      } else if (gameMode === 'pvc') {
        if (difficulty === 'easy') {
          finalMatch3Mode = 'stars'; // 简单难度 → 星星消除模式
        } else {
          finalMatch3Mode = 'happy'; // 中等/困难难度 → 开心消消乐模式
        }
      } else {
        finalMatch3Mode = 'classic'; // 默认
      }
    }
    return (
      <Match3Router
        initialMode={finalMatch3Mode}
        onBackToMenu={onBackToMenu}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  if (gameType === 'connectfour') {
    return (
      <ConnectFourGame
        gameMode={gameMode}
        difficulty={difficulty}
        onBackToMenu={onBackToMenu}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  if (gameType === 'hnefatafl') {
    return (
      <HnefataflGame
        gameMode={gameMode}
        difficulty={difficulty}
        onBackToMenu={onBackToMenu}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  if (gameType === 'straight') {
    return (
      <StraightChessGame
        gameMode={gameMode}
        difficulty={difficulty}
        playerColor={playerColor}
        onBackToMenu={onBackToMenu}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  if (gameType === 'tablut') {
    return (
      <TablutGame
        gameMode={gameMode}
        difficulty={difficulty}
        onBackToMenu={onBackToMenu}
        onBackToModeSelect={onBackToModeSelect}
      />
    );
  }

  // 默认渲染五子棋游戏
  return (
    <Game
      gameMode={gameMode}
      difficulty={difficulty}
      gameType={gameType}
      onBackToMenu={onBackToMenu}
      onBackToModeSelect={onBackToModeSelect}
    />
  );
};

export default GameRouter;